module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-instructions-for-use.1474b739.jpg";